import { useMutation, useQueryClient } from '@tanstack/react-query';
import { teamsService } from '../services/teamsService';

export const useRemoveUserFromTeam = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ teamId, userId }: { teamId: string; userId: string }) =>
      teamsService.removeUserFromTeam(teamId, userId),

    onSuccess: (_, variables) => {
      // Invalidate team members list
      queryClient.invalidateQueries({ queryKey: ['team-members', variables.teamId] });
      // Invalidate team details (may have updated member count)
      queryClient.invalidateQueries({ queryKey: ['teams', variables.teamId] });
    }
  });
};
